import * as type from '../mutation-types'

export const loginRegisterStore = {
  namespaced: true,
  state: {
    /* API URLS */
    apiUrls: {
      login: 'login',
      logout: 'logout',
      register: 'register',
      activation: 'email/activation',
      verification: 'email/verification',
      emailverification: 'new-email/verification',
      resetpassword: 'email/resetpassword',
      verificationPassword: 'email/verificationPassword'
    },
    loginEmail: null,
    showVerifyLink: false,
    wasVerifyEmailSend: false,
    wasPasswordEmailSend: false,
    loggedIn: false
  },
  mutations: {
    [type.AUTH_RESET] (state) {
      state.loginEmail = null
      state.showVerifyLink = false
      state.wasVerifyEmailSend = false
      state.wasPasswordEmailSend = false
      state.loggedIn = false
    },
    [type.AUTH_SET_LOGIN_EMAIL] (state, email) {
      state.loginEmail = email
    },
    [type.AUTH_SHOW_VERIFY_LINK] (state, value) {
      state.showVerifyLink = value
    },
    [type.AUTH_WAS_VERIFY_EMAIL_SEND] (state, value) {
      state.wasVerifyEmailSend = value
    },
    [type.AUTH_WAS_PASSWORD_EMAIL_SEND] (state, value) {
      state.wasPasswordEmailSend = true
    }
  },
  getters: {
    loginUrl: (state, getters, rootState) => {
      return rootState.apiUrls.domain + state.apiUrls.login
    },
    logoutUrl: (state, getters, rootState) => {
      return rootState.apiUrls.domain + state.apiUrls.logout
    },
    registerUrl: (state, getters, rootState) => {
      return rootState.apiUrls.domain + state.apiUrls.register
    },
    sendActivationMailUrl: (state, getters, rootState) => {
      return rootState.apiUrls.domain + state.apiUrls.activation
    },
    sendResetPasswordMailUrl: (state, getters, rootState) => {
      return rootState.apiUrls.domain + state.apiUrls.resetpassword
    },
    sendVerificationToken: (state, getters, rootState) => {
      return rootState.apiUrls.domain + state.apiUrls.verification
    },
    sendEmailVerificationToken: (state, getters, rootState) => {
      return rootState.apiUrls.domain + state.apiUrls.emailverification
    },
    verifyPasswordToken: (state, getters, rootState) => {
      return rootState.apiUrls.domain + state.apiUrls.verificationPassword
    }
  },
  actions: {
    async setLoginData ({ commit, dispatch, getters, rootState }, data) {
      commit(type.ROOT_SET_LOGGED_IN, true, { root: true })
      commit(type.ROOT_SET_TOKEN, data.token, { root: true })
      commit(type.ROOT_SET_INIT, data.init, { root: true })
      try {
        // set username and id
        if (data.user.username) {
          commit('managerStore/MANAGER_SET_NAME', data.user.username, { root: true })
        }
        if (data.user.id) {
          commit('managerStore/MANAGER_SET_ID', data.user.id, { root: true })
        }
        if (data.user.imageId) {
          commit('managerStore/MANAGER_SET_IMAGE_ID', data.user.imageId, { root: true })
        }
        if (data.user.manager_since) {
          commit('managerStore/MANAGER_SINCE', data.user.manager_since, { root: true })
        }

        // set team and players
        if (data.user.teamname) {
          commit('teamStore/TEAM_SET_TEAM_NAME', data.user.teamname, { root: true })
        }
        if (data.user.teamimage) {
          commit('teamStore/TEAM_SET_TEAM_LOGO', data.user.teamimage, { root: true })
        }
        if (data.user.wurfzahl) {
          commit('teamStore/TEAM_SET_WURFZAHL', data.user.wurfzahl, { root: true })
        }
        if (data.user.liga) {
          commit('teamStore/TEAM_SET_LIGA', data.user.liga, { root: true })
        }
        if (data.user.players) {
          commit('teamStore/TEAM_SET_PLAYERS', data.user.players, { root: true })
        }

        if (data.user.newPlayerCounter) {
          commit('teamStore/TEAM_SET_CREATED_NEW_PLAYERS_COUNTER', data.user.newPlayerCounter, { root: true })
        }
        if (data.user.createdPlayers) {
          commit('teamStore/TEAM_SET_CREATED_NEW_PLAYERS', data.user.createdPlayers, { root: true })
        }

        // set money sponsoren
        if (data.sponsoren) {
          commit('moneyStore/MONEY_SET_ALL_SPONSOREN', data.sponsoren, { root: true })
        }
        if (data.user.sponsor) {
          commit('moneyStore/MONEY_SET_SPONSOR', data.user.sponsor, { root: true })
        }
        if (data.user.finanzen) {
          commit('moneyStore/MONEY_SET_GIRO', data.user.finanzen.giro, { root: true })
          // commit('moneyStore/MONEY_SET_SPAR', data.user.finanzen.spar, { root: true })
          // commit('moneyStore/MONEY_SET_FINANZEN', data.user.finanzen, { root: true })
        }
        // fahrzeug
        if (data.user.fahrzeug) {
          commit('fahrzeugStore/FAHRZEUG_SET_MY_FAHRZEUG', data.user.fahrzeug, { root: true })
        }
        // kegelbahn
        if (data.user.kegelbahn) {
          commit('kegelbahnStore/KEGELBAHN_SET_MY_KEGELBAHN', data.user.kegelbahn, { root: true })
        }
        if (data.user.ausbau) {
          commit('fahrzeugStore/FAHRZEUG_SET_AUSBAU', data.user.ausbau, { root: true })
          commit('kegelbahnStore/KEGELBAHN_SET_AUSBAU', data.user.ausbau, { root: true })
        }
        if (data.user.aufstellung) {
          commit('teamStore/TEAM_SET_AUFSTELLUNG', data.user.aufstellung, { root: true })
        }
        // set datat for buero screeen
        if (data.office) {
          commit(type.ROOT_SET_OFFICE_DATA, data.office, { root: true })
        }
        // set saison data
        if (data.saison) {
          commit('saisonStore/SAISON_SET_SAISON', data.saison, { root: true })
        }
        // if (!rootState.init && !getters['chatStore/getConnectionStatus']) {
        //   dispatch('chatStore/initChatsystem', null, { root: true })
        // }
      } catch (e) {
        // console.log(e)
      }
    },
    // login an user
    async loginUser ({ commit, getters, dispatch }, payload) {
      commit(type.AUTH_WAS_VERIFY_EMAIL_SEND, false)
      commit(type.AUTH_WAS_PASSWORD_EMAIL_SEND, false)
      // set transport option
      const transportOptions = {
        url: getters.loginUrl,
        data: {
          email: payload.email,
          password: payload.password
        },
        withoutAuth: true
      }
      // send data to server
      const response = await dispatch('sendDataToServer', transportOptions, { root: true })
      let ret = true
      if (response.success) {
        // set all login data
        await dispatch('setLoginData', response.data)
      } else {
        ret = false
      }

      return ret
    },
    // register an user
    async registerUser ({ commit, getters, dispatch }, payload) {
      // set transport option
      const transportOptions = {
        url: getters.registerUrl,
        data: {
          email: payload.email,
          password: payload.password
        },
        withoutAuth: true
      }
      // send data to server
      const response = await dispatch('sendDataToServer', transportOptions, { root: true })
      let ret = true
      if (!response.success) {
        ret = false
      }

      return ret
    },
    // login an user
    async resetPasswordMail ({ commit, getters, dispatch }, email) {
      // set transport option
      const transportOptions = {
        url: getters.sendResetPasswordMailUrl,
        data: {
          email: email
        },
        withoutAuth: true
      }
      // send data to server
      const response = await dispatch('sendDataToServer', transportOptions, { root: true })
      let ret = true
      if (!response.success) {
        ret = false
      }

      return ret
    },
    // send activstion email to user
    async sendActivationMail ({ commit, getters, dispatch }, email) {
      // set transport option
      const transportOptions = {
        url: getters.sendActivationMailUrl,
        data: {
          email: email
        },
        withoutAuth: true
      }
      // send data to server
      const response = await dispatch('sendDataToServer', transportOptions, { root: true })
      let ret = true
      if (!response.success) {
        ret = false
      }

      return ret
    },

    // login an user
    async sendVerificationToken ({ commit, getters, dispatch }, payload) {
      // set transport option
      const transportOptions = {
        url: getters.sendVerificationToken,
        data: {
          token: payload.token,
          email: payload.email
        },
        withoutAuth: true
      }
      // send data to server
      const response = await dispatch('sendDataToServer', transportOptions, { root: true })
      let ret = true
      if (response.success) {
        // set all user data
        await dispatch('setLoginData', response.data)
        commit(type.AUTH_WAS_VERIFY_EMAIL_SEND, false)
        commit(type.AUTH_WAS_PASSWORD_EMAIL_SEND, false)
      } else {
        ret = false
      }

      return ret
    },
    // password reset token
    async verifyPasswordToken ({ commit, getters, dispatch }, payload) {
      // set transport option
      const transportOptions = {
        url: getters.verifyPasswordToken,
        data: {
          token: payload.token,
          email: payload.email
        },
        withoutAuth: true
      }
      // send data to server
      const response = await dispatch('sendDataToServer', transportOptions, { root: true })
      let ret = true
      if (response.success) {
        // set all the user data
        await dispatch('setLoginData', response.data)
      } else {
        ret = false
      }

      return ret
    },
    // e-mail-verification
    async sendEmailVerificationToken ({ commit, getters, dispatch }, payload) {
      // set transport option
      const transportOptions = {
        url: getters.sendEmailVerificationToken,
        data: {
          token: payload.token,
          email: payload.email
        },
        withoutAuth: true
      }
      // send data to server
      const response = await dispatch('sendDataToServer', transportOptions, { root: true })
      let ret = true
      if (!response.success) {
        ret = false
      }

      return ret
    }
  }
}
